import { useLang } from "../i18n/LanguageContext";

/**
 * PremiumLock — shows a premium-locked overlay when the parent has not paid.
 * Props:
 *  - onGoToBookings: () => void   // switch to bookings tab
 *  - hasPendingBooking: bool
 */
export default function PremiumLock({ onGoToBookings, hasPendingBooking }) {
  const { t } = useLang();
  return (
    <div
      data-testid="premium-lock"
      className="rounded-2xl bg-gradient-to-br from-[#161616] to-[#1a0e16] border border-[#e8559a]/40 p-8 sm:p-10 text-center"
    >
      <div className="text-5xl mb-3">🔒</div>
      <h3 className="font-bebas text-3xl sm:text-4xl tracking-widest text-[#e8559a] mb-2">
        {t("premium_locked_title")}
      </h3>
      <p className="text-neutral-300 max-w-xl mx-auto leading-relaxed mb-6">
        {t("premium_locked_message")}
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-lg mx-auto mb-6 text-left">
        {[
          ["🎬", t("videos")],
          ["💬", t("coach_feedback")],
          ["📈", t("dev_timeline")],
          ["⚡", t("dev_before_after_title")],
        ].map(([emoji, label]) => (
          <div
            key={label}
            className="flex items-center gap-2.5 rounded-xl bg-[#0f0f0f] border border-[#252525] px-3 py-2.5"
          >
            <span className="text-xl">{emoji}</span>
            <span className="text-sm text-neutral-200">{label}</span>
          </div>
        ))}
      </div>

      {hasPendingBooking ? (
        <>
          <div className="inline-flex items-center gap-2 mb-4 text-sm text-amber-300 bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-1.5">
            ⧗ {t("premium_locked_pending")}
          </div>
          <div>
            <button
              onClick={onGoToBookings}
              data-testid="premium-lock-go-bookings"
              className="px-6 py-3 rounded-lg bg-[#e8559a] hover:bg-[#c9407f] text-white font-bebas text-lg tracking-widest transition-colors"
            >
              💳 {t("premium_locked_go_bookings")}
            </button>
          </div>
        </>
      ) : (
        <div className="text-sm text-neutral-500 italic">
          {t("premium_locked_no_booking")}
        </div>
      )}
    </div>
  );
}
